// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/clock.js';

import { paths } from '../generated/clock';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('clock', Original, paths);
